<div class="test-selector">
  <div class="selector-header">
    <dojo-icon icon="flask-vial" [size]="13" />
    <span>Select Test</span>
  </div>

  @for (group of groups; track group.label) {
    <div class="group">
      <div class="group-label">{{ group.label }}</div>
      <div class="group-items">
        @for (item of group.items; track item.type) {
          <button class="test-card" [class.selected]="selected() === item.type" (click)="onSelect(item.type)">
            <div class="card-icon">
              <dojo-icon [icon]="item.icon" [size]="15" />
            </div>
            <div class="card-content">
              <div class="card-header">
                <span class="card-label">{{ item.label }}</span>
                <span class="col-badge">{{ colLabel(item.columnCount) }}</span>
              </div>
              <span class="card-description">{{ item.description }}</span>
            </div>
            @if (selected() === item.type) {
              <div class="selected-dot"></div>
            }
          </button>
        }
      </div>
    </div>
  }
</div>
